import { TrainingSession } from './training-session';
import { UserNode } from './user-node';
import { Team } from './team';

export class TrainingSessionAssignment {
  id: number;
  user: UserNode;
  session: number;
  dateDebut: boolean;
  dateFin: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/training-session-assignment.ts